import { useQuery } from '@tanstack/react-query'

import { useQueryErrorAlert } from '@hooks/useQueryErrorAlert'

import { useAuthenticatedUser } from '../../../auth/hooks/useAuthenticatedUser'
import { fetchTemplates, initialState } from '../services/fetchTemplates'
import type { ContractinstellingenSearchFilters } from '../types/ContractinstellingenSearch'

export { queryKey, useActiviteitTemplatesSearch, useTemplatesSearch }

const queryKey = 'hoofdleiding-templates'
const activiteitenQueryKey = 'hoofdleiding-activiteit-templates'

const useSearch = (key: string, filters: ContractinstellingenSearchFilters) => {
  const { hasPermissions } = useAuthenticatedUser()

  const {
    data,
    isFetching: isLoading,
    error,
    errorUpdatedAt,
  } = useQuery({
    queryKey: [key, filters],
    queryFn: () => fetchTemplates(filters),
    enabled: hasPermissions && !!filters.verantwoordelijke,
    refetchOnMount: 'always',
  })

  useQueryErrorAlert(error, errorUpdatedAt, 'Fout bij ophalen van templates')

  return {
    data: data || initialState.data,
    isLoading,
    error,
  }
}

const useTemplatesSearch = ({
  filters,
}: {
  filters: ContractinstellingenSearchFilters
}) => useSearch(queryKey, filters)

const useActiviteitTemplatesSearch = ({
  filters,
}: {
  filters: ContractinstellingenSearchFilters
}) => useSearch(activiteitenQueryKey, filters)
